export const stringToFloat = value => {
  if (!!value) {
    if (typeof value === 'number') return value
    return parseFloat(value.split('.').join('').split(',').join('.'))
  } else {
    return null
  }
}


// WEBPACK FOOTER //
// ./src/utils/numberFormater.js